import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector, useDispatch } from 'react-redux';
import { HelperStyles } from '@stencil/commonstories/src/HelperStyles';
import {
  seoStateSelector,
  flightSearchDataSelector,
  bookingReviewDataSelector,
  hasSeoDataSelector,
  flavourSelector,
  offerOverlaySelector,
  bannerDetailsSelector,
  selectedFlightSelector,
  seoOmnitureInfoSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import goToReviewPage from '@stencil/flights-utils/src/go-to-review-page';
import * as S from '@stencil/dstories/src/components/SRP/SeoSrpLayout/seo-srp-layout.styles';
import SomethingWentWrong from '@stencil/something-went-wrong';
// import BreadCrumbs from '@stencil/commonstories/src/components/Seo/breadcrumbs/breadcrumbs';
import {
  gaPageViewThunk,
  gaPushPageInfoThunk,
  gaGenericEventThunk
} from '@stencil/flights-ga-thunks';
import {
  updateSelectedFlight,
  updateFareCalendarData,
  updateFareTrendsData
} from '@stencil/flights-seo-reducers/src/SRP/redux/actions';
import Footer from '@stencil/dstories/src/components/SRP/SeoFooter/footer';
import OfferOverlay from '../../../../../../flights/dstories/src/components/SRP/offer-overlay/offer-overlay';
import TopBanner from '@stencil/dstories/src/components/SRP/top-banner/top-banner';
import { getFareData } from '@ibibo/get-fare-calendar-data';

import SearchWidget from '../search-widget/search-widget';
import SrpSeoLeft from './srp-seo-left';
import SrpSeoRight from './srp-seo-right';
import { experimentMetaDataSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import { flightsAnalyticsLoggingThunk } from '@stencil/flights-seo-reducers/src/utils/common-thunks';

// import Footer from '@stencil/footer';

const SrpSeoDweb = () => {
  const dispatch = useDispatch();

  const seoState = useSelector(seoStateSelector);
  const flavour = useSelector(flavourSelector);
  const hasSeoData = useSelector(hasSeoDataSelector);
  const bookingReviewData = useSelector(bookingReviewDataSelector);
  const offerOverlayData = useSelector(offerOverlaySelector);
  const bannerDetails = useSelector(bannerDetailsSelector);
  const selectedFlight = useSelector(selectedFlightSelector);
  const experimentMetaData = useSelector(experimentMetaDataSelector);
  const seoOmnitureInfo = useSelector(seoOmnitureInfoSelector) || {};
  const hasBannerData = bannerDetails && Object.keys(bannerDetails).length > 0;

  const {
    source,
    destination,
    meta,
    meta_title,
    metaLinks,
    travelType,
    breadcrumb,
    footer_data,
    journeyType,
    departure,
    arrival,
    searchWidget,
    queryType,
    language
  } = seoState;

  useEffect(() => {
    dispatch(gaPushPageInfoThunk('SRPSeo', flightSearchDataSelector, flavour));
    dispatch(gaPageViewThunk('FlightsSRPSeo', flightSearchDataSelector));
    gaGenericEventThunk('Seo_Flight_City_Page');
  }, []);

  useEffect(() => {
    if (seoOmnitureInfo && Object.keys(seoOmnitureInfo).length > 0) {
      dispatch(
        flightsAnalyticsLoggingThunk({
          omnitureInfo: {
            pageType: 'SEO',
            eventName: 'pageLoad'
          }
        })
      );
    }
  }, [seoOmnitureInfo && Object.keys(seoOmnitureInfo).length > 0]);

  if (!hasSeoData) {
    return (
      <div
        style={{
          padding: '10px',
          backgroundColor: 'white',
          height: '100%'
        }}
      >
        <SomethingWentWrong
          containerStyles={{
            height: '100vh'
          }}
        />
      </div>
    );
  }

  const [showDisableOverlay, setShowDisableOverlay] = useState(false);
  const handleHulkResponse = () => {
    setShowDisableOverlay(false);
    dispatch(updateSelectedFlight({}));
  };

  useEffect(() => {
    const { bookData = {} } = bookingReviewData;
    const { o = undefined } = bookData ? bookData : {};
    if (o && o.length > 0) {
      const isMSE = o.length > 1;
      // const isBundle = o[0].al ? true : false;
      if (!isMSE) {
        setShowDisableOverlay(true);
        goToReviewPage(
          flavour,
          bookingReviewData,
          travelType,
          experimentMetaData,
          true,
          handleHulkResponse,
          selectedFlight
        );
      }
    }
  }, [bookingReviewData]);

  const fetchFareCalendareData = async (mode, updateFareTrend = false) => {
    const fareData: { data?: Object; stats?: Object } = await getFareData(mode, searchWidget);
    if (updateFareTrend) {
      return dispatch(updateFareTrendsData(fareData));
    }
    return dispatch(updateFareCalendarData(fareData));
  };

  return (
    <>
      <HelperStyles />
      <Helmet title={meta_title} meta={meta} link={metaLinks} />
      <div className="WrapperSc">
        {showDisableOverlay ? <S.DisableClickOverlay /> : null}
        <S.Wrapper className="width100 flexCol">
          <SearchWidget fetchFareCalendareData={fetchFareCalendareData} language={language} />
          <S.Container>
            {/* <BreadCrumbs breadcrumb={breadcrumb} isDweb={true} /> */}
            {(hasBannerData && (
              <TopBanner
                receivedAllChunks={true}
                bannerDetails={bannerDetails}
                hasBannerData={hasBannerData}
              />
            )) ||
              null}
            <S.RightWrap>
              <SrpSeoRight fetchFareCalendareData={fetchFareCalendareData} />
            </S.RightWrap>
            <S.LeftWrap className="flexCol">
              <SrpSeoLeft />
            </S.LeftWrap>
          </S.Container>
          <OfferOverlay offerOverlayData={offerOverlayData} />
        </S.Wrapper>
        <Footer html={footer_data} />
      </div>
    </>
  );
};

export default SrpSeoDweb;
